//Open modal boxes in PDP in desktop
if (window.innerWidth > 1023) {
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();      
        document.querySelector('.product-modal-overlay').style.visibility = "hidden";
      }

      show(opener) {
        super.show(opener);
        document.querySelector('.product-modal-overlay').style.visibility = "visible";
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
            element.classList.add('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }
}

$('.product-media-modal__content').slick({
  slidesToShow: 1,
  infinite: true,
  centerMode: false,
  slidesToScroll: 1,
  centerMode: false,
  arrows: true,
  autoplay: false,
  dots: true,
});